import actions from './actions';
import getters from './getters';
import lookupsActions from './lookups/actions';
import lookupsState from './lookups/state';
import mutations from './mutations';
import requestDetailActions from './request-detail-actions';
import state from './state';

export default {
  namespaced: true,
  actions: {
    ...actions,
    ...lookupsActions,
    ...requestDetailActions,
  },
  getters,
  mutations,
  state: {
    ...state,
    ...lookupsState,
  },
};
